import atr from "./atr";
import { keltner as defaultOptions } from "./defaultOptionsForComputation";
import { getMACalculator, isFiniteNumber } from "../utils";

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 1),
    );
    const multiplier = Number(
      options?.multiplier ?? defaultOptions.multiplier ?? 1,
    );
    const sourcePath =
      options?.sourcePath ?? defaultOptions.sourcePath ?? "close";
    const movingAverageType =
      options?.movingAverageType || defaultOptions.movingAverageType || "ema";

    // Get MA calculator using centralized utility
    const maFactory = getMACalculator(movingAverageType);
    const maCalculator = maFactory().options({
      windowSize: period,
      sourcePath,
    });

    // Calculate ATR using the same period
    const atrCalculator = atr().options({ windowSize: period });

    const maValues = maCalculator(data);
    const atrValues = atrCalculator(data);

    const results = new Array(data.length).fill(undefined);

    for (let i = 0; i < data.length; i += 1) {
      const mid = maValues[i];
      const width = atrValues[i];

      if (!isFiniteNumber(mid) || !isFiniteNumber(width)) {
        continue;
      }

      results[i] = {
        top: mid + multiplier * width,
        middle: mid,
        bottom: mid - multiplier * width,
      };
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 1),
    );
    return period - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
